import { useEffect, useState } from 'react';
import { useDrawer } from '../../../../shared/drawer';
import { Table } from "../../../../elements/table";
import { PageBody } from '../../../../elements/page-body';
import { AccidentesTabForm } from './accidentes-tab-form';




export const AccidentesTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);

    const handleNewAction = () => {
        open('common.form-title.new', <AccidentesTabForm close={handleClose} vehicleId={item} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        onAction();
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            newActionTitle={'common.form-title.new'}
            title={'common.label.accidentes'}
        >
            <Table
                path={`/fleet/accidents/?vehicle=${item}&`}
                deletePath={`/fleet/accidents/`}
                callBeforeDrawerClosed={handleClose}
                Form={AccidentesTabForm}
                withPagination
                refresh={refresh}
                headers={[
                    {
                        key: 'date',
                        type: 'datetime',
                        label: 'common.label.fecha-hora',
                    },
                    {
                        key: 'location',
                        label: 'common.label.ubicacion',
                    },
                    {
                        key: 'driver',
                        subKey: 'full_name',
                        label: 'common.label.conductor',
                    },
                    {
                        key: 'description',
                        label: 'common.form-label.descripcion',
                    },
                ]}
            />
        </PageBody>
    );
};